var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"rel":_vm.opensInNewWindow ? 'noopener' : null},domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":_vm.processLink}})}
var staticRenderFns = []

export { render, staticRenderFns }